var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowMoreIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "54px",
    viewBox: "0 0 64 54",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8A9F492E-F916-4EB5-8B34-48123C159B21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Putanja-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ai-chat-2-copy",
    transform: "translate(-117.000000, -2967.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11-Copy-2",
    transform: "translate(117.000000, 2967.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery-view-2",
    fill: "#696969",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 C1.34316,0 0,1.34316 0,3 L0,21 C0,22.6569 1.34316,24 3,24 L24,24 C25.6569,24 27,22.6569 27,21 L27,3 C27,1.34316 25.6569,0 24,0 L3,0 Z M6,18 L6,6 L21,6 L21,18 L6,18 Z M3,30 C1.34316,30 0,31.3431 0,33 L0,51 C0,52.6569 1.34316,54 3,54 L24,54 C25.6569,54 27,52.6569 27,51 L27,33 C27,31.3431 25.6569,30 24,30 L3,30 Z M6,48 L6,36 L21,36 L21,48 L6,48 Z M33,3 C33,1.34316 34.3431,0 36,0 L57,0 C58.6569,0 60,1.34316 60,3 L60,21 C60,22.6569 58.6569,24 57,24 L36,24 C34.3431,24 33,22.6569 33,21 L33,3 Z M39,6 L39,18 L54,18 L54,6 L39,6 Z M36,30 C34.3431,30 33,31.3431 33,33 L33,51 C33,52.6569 34.3431,54 36,54 L57,54 C58.6569,54 60,52.6569 60,51 L60,33 C60,31.3431 58.6569,30 57,30 L36,30 Z M39,48 L39,36 L54,36 L54,48 L39,48 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMoreIcon);
export default __webpack_public_path__ + "static/media/show-more-icon.178e4db12eb5facacb48a2b26d5ed2fa.svg";
export { ForwardRef as ReactComponent };